import React from "react";
import { VideoStore } from "../store/VideoStore";

export const VideoStoreContext = React.createContext<VideoStore>(
    {} as VideoStore,
);
